import React from "react";
import BaseKPIPage from "./BaseKPIPage";
import { KPI_PAGE_CONFIG } from "../constants/kpiConstants";
/**
 * KPI Page (Legacy/General)
 * Uses the reusable BaseKPIPage with traffic speed configuration
 */
export default function TrafficSpeedInsights() {
  return (
    <BaseKPIPage
      config={KPI_PAGE_CONFIG.trafficSpeed}
      showInterval={false}
      showEndDate={true}
      showAggregation={true}
    />
  );
}